<template>
  <div :id="mainId" class="al-paragraph" test-id="al-paragraph">
    <div class="al-paragraph-content">
      <slot>
        <template v-if="text">
          <div>
            <p>{{ text }}</p>
          </div>
        </template>
        <template v-if="html">
          <div :ref="`html-${mainId}`"></div>
        </template>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    html: {
      type: String,
      default: null
    }
  },
  computed: {
    mainId() {
      // eslint-disable-next-line no-underscore-dangle
      const id = this.id ? this.id : this._uid;
      return `al-paragraph-${id}`;
    },
    parseHTML() {
      let newHTML = '';
      newHTML = this.html;
      return newHTML;
    }
  },
  mounted() {
    if (this.$refs[`html-${this.mainId}`]) {
      this.$refs[`html-${this.mainId}`].innerHTML = this.parseHTML;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Variables
 */

$font-color: #36403f;
$font-size: 16px;

.al-paragraph {
  .al-paragraph-content {
    color: $font-color;
    font-size: $font-size;
  }
}
</style>
